var DateSelectorEvents = (function() {
    var _events_display = 'display';

    return function() {

        var _eventHandler = $({});

        var subscribeOnEvent = function (eventName, cb) {
            _eventHandler.on(eventName, cb);
            //_eventHandler.on(eventName,  function() {
            //    console.log(eventName, cb);
            //});
        }

        return {
            onDisplay: function(cb) {
                subscribeOnEvent(_events_display, cb);
            },

            displayYears: function () {
                _eventHandler.trigger(_events_display, 'years');
            },

            displayMonths: function () {
                _eventHandler.trigger(_events_display, 'months');
            },

            displayDays: function () {
                _eventHandler.trigger(_events_display, 'days');
            }
        }
    }
})();